export default [
  {
    prop: 'title',
    label: '内容',
    minWidth: 300,
    tooltip: true
  },
  {
    prop: 'is_read',
    label: '状态',
    minWidth: 100
  },
  {
    prop: 'create_time',
    label: '时间',
    minWidth: 180,
    tooltip: true
  },
  {
    prop: 'action',
    width: '100px',
    label: '操作'
  }
]
